<template>
  <li class="kanto" @click="setCookie()">
    <a :href="festa.site_url">
      <div class="clm">
        <div class="clm-heading">
          <h3 class="clm-title">{{festa.name}}</h3>
        </div>
        <p class="date" v-html="$options.filters.setSchedule(festa.schedules)"></p>
        <p class="get">チケットを取る</p>
        <p class="place"></p>
      </div>
    </a>
  </li>
</template>

<script>
import moment from 'moment'

export default {
  data: () => ({
    scrollY: 0
  }),
  props: {
    festa: {}
  },
  filters: {
    setSchedule (schedules) {
      moment.locale('ja', { weekdays: ['日', '月', '火', '水', '木', '金', '土'] })
      const len = Object.keys(schedules).length
      const start = schedules[0].event_date
      const startIsHoliday = schedules[0].is_holiday
      const end = schedules[len - 1].event_date
      const endIsHoliday = schedules[len - 1].is_holiday
      const startY = moment(start).format('YYYY')
      const startM = moment(start).format('M')
      const startD = moment(start).format('D')
      const startHM = moment(startY + '-' + moment(start).format('MM') + '-' + moment(start).format('DD') + ' ' + schedules[0].open_at).format('H:mm')
      const startW = moment(start).format('dddd')
      const startHoliday = startIsHoliday ? '・祝' : ''
      const endY = moment(end).format('YYYY')
      const endM = moment(end).format('M')
      const endD = moment(end).format('D')
      const endHM = moment(endY + '-' + moment(end).format('MM') + '-' + moment(end).format('DD') + ' ' + schedules[0].close_at).format('H:mm')
      const endW = moment(end).format('dddd')
      const endHoliday = endIsHoliday ? '・祝' : ''
      if (len > 1) {
        if (startM === endM) {
          return '<strong>' + startM + '</strong>/<strong>' + startD + '</strong>(' + startW + startHoliday + ')〜<strong>' + endD + '</strong>(' + endW + endHoliday + ')<br><strong>' + startHM + '〜' + endHM + '</strong>'
        } else {
          return '<strong>' + startM + '</strong>/<strong>' + startD + '</strong>(' + startW + startHoliday + ')〜<strong>' + endM + '</strong>/<strong>' + endD + '</strong>(' + endW + endHoliday + ')<strong><br>' + startHM + '〜' + endHM + '</strong>'
        }
      } else {
        return '<strong>' + startM + '</strong>/<strong>' + startD + '</strong>(' + startW + startHoliday + ')<br><strong>' + startHM + '〜' + endHM + '</strong>'
      }
    }
  },
  methods: {
    setCookie () {
      document.cookie = 'scrolly=' + this.scrollY
    },
    calculateScrollY () {
      this.scrollY = window.scrollY
    },
    getScrollyByCookie () {
      const cookies = document.cookie
      const cookiesArray = cookies.split(';')
      for (var c of cookiesArray) {
        const cArray = c.split('=')
        if (cArray[0].indexOf('scrolly') !== -1) {
          return cArray[1]
        }
      }
    }
  },
  mounted () {
    const scrollY = this.getScrollyByCookie()
    if (scrollY) {
      scrollTo(0, scrollY)
    }
    window.addEventListener('scroll', this.calculateScrollY)
  }
}
</script>
<style lang="sass" scoped>
a
  display: block
  color: #6c5a50
  border-radius: 5px
  overflow: hidden
  text-decoration: none
  position: relative
  height: 100%
  .clm
    height: 100%
    .date
      line-height: 2em
    &::after
      content: ''
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      z-index: 10
    .get
      font-size: 16px
      font-weight: bold
</style>
